/* eslint-disable no-unused-vars */
import axios from "axios";

export class CrudService {
  constructor(resource) {
    this.resource = resource;
    this.apiUrl = `${process.env.VUE_APP_API_URL}/${this.resource}`;
    // this.apiUrl = 'http://localhost:3000/' + this.resource;
  }

  static of(resource) {
    return new CrudService(resource);
  }

  getList(pagination, searchQuery, action) {
    if (pagination.rowsPerPage == -1) {
      pagination.rowsPerPage = 1000;
    }
    var params = {
      page: pagination.page - 1,
      size: pagination.rowsPerPage,
      paging: pagination.paging
    };
    if (pagination.sortBy) {
      params["orderBy"] = pagination.sortBy;
      params["direction"] = pagination.descending ? "DESC" : "ASC";
    }
    if (searchQuery) {
      params["queryRule"] = searchQuery.queryRule ? searchQuery.queryRule : "";
      params["isExcel"] = searchQuery.isExcel;
      params["hiddenConditions"] = searchQuery.hiddenConditions;
      params["sqlQuery"] = searchQuery.sqlQuery;
      params["columns"] = searchQuery.columns;
      params["tableName"] = searchQuery.tableName;
      params["product"] = searchQuery.product;
    }

    if (action) {
      return axios.post(`${this.apiUrl}/${action}`, params);
    } else {
      return axios.post(`${this.apiUrl}/list`, params);
    }
  }

  getFilterList(action, filterItem) {
    if (action) {
      return axios.post(`${this.apiUrl}/${action}`, filterItem);
    } else {
      return axios.post(`${this.apiUrl}/list`, filterItem);
    }
  }

  downloadExcel(pagination, searchQuery) {
    let searchParams = {
      paging: false
    };
    if (pagination.sortBy) {
      searchParams["orderBy"] = pagination.sortBy;
      searchParams["direction"] = pagination.descending ? "DESC" : "ASC";
    }
    if (searchQuery) {
      searchParams["queryRule"] = searchQuery.queryRule
        ? searchQuery.queryRule
        : "";
      searchParams["isExcel"] = true;
      searchParams["hiddenConditions"] = searchQuery.hiddenConditions;
      searchParams["tableFieldList"] = searchQuery.tableFieldList;
      searchParams["sqlQuery"] = searchQuery.sqlQuery;
      searchParams["columns"] = searchQuery.columns;
      searchParams["tableName"] = searchQuery.tableName;
    }
    axios({
      url: `${this.apiUrl}/excel`,
      method: "POST",
      data: searchParams,
      responseType: "blob", // important
      headers: { Accept: "application/vnd.ms-excel" }
    }).then(response => {
      if (response) {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", this.resource + ".xls");
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
      }
    });
  }
  importData(importFields) {
    axios({
      url: `${this.apiUrl}/import`,
      method: "POST",
      data: importFields,
      responseType: "json"
    }).then(response => {
      if (response) {
        console.log(response.data);
      }
    });
  }

  getAllWithConditions(conditions) {
    //user/1/menu/2
    let addStr = '';
    Object.entries(conditions).forEach(([key, val]) => {
      addStr = addStr + key + '/' + val + '/';
    });
    return axios.get(`${this.apiUrl}/` + addStr);
  }

  getAll() {
    return axios.get(`${this.apiUrl}/all`);
  }

  getInList(fieldName, list) {
    return axios.post(
      `${this.apiUrl}/inlist?fieldName=` + fieldName + "&list=" + list
    );
  }

  getItem(id) {
    if (id) {
      return axios.get(`${this.apiUrl}/` + id);
    } else {
      return axios.get(`${this.apiUrl}/`);
    }
  }

  createItem(item) {
    return axios.post(`${this.apiUrl}`, item);
  }

  updateItem(item) {
    return axios.put(`${this.apiUrl}`, item);
  }

  deleteItem(id) {
    return axios.delete(`${this.apiUrl}/` + id);
  }

  postDeleteItem(id) {
    return axios.post(`${this.apiUrl}/delete` + id);
  }

  createChildItem(parentId, item) {
    return axios.post(`${this.apiUrl}/` + parentId, item);
  }

  updateChildItem(parentId, item) {
    return axios.put(`${this.apiUrl}/` + parentId, item);
  }

  deleteItemList(ids) {
    return axios.post(`${this.apiUrl}/bulk-delete`, { ids: ids });
  }

  getColumnsListFromQuery(query) {
    return axios.post(`${this.apiUrl}/get-columns`, { sqlQuery: query });
  }

  validateQuery(query) {
    return axios.post(`${this.apiUrl}/validate-query`, { sqlQuery: query });
  }
}
